import 'moment/locale/bn';
import * as FullCalendar from 'fullcalendar';

/* Bangla Translation for jQuery UI date picker plugin. */

FullCalendar.datepickerLocale('bn', 'bn', {
    closeText: "বন্ধ করুন",
    prevText: "&#x3C;পূর্ববর্তী",
    nextText: "পরবর্তী&#x3E;",
    currentText: "আজ",
    monthNames: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthNamesShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    dayNames: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    dayNamesShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    dayNamesMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
    weekHeader: "সপ্তাহ",
    dateFormat: "dd-mm-yy",
    firstDay: 0,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ""
});


FullCalendar.locale("bn", {
    dir: 'ltr',
    buttonText: {
        prev: "পূর্ববর্তী",
        next: "পরবর্তী",
        today: "আজ",
        month: "মাস",
        week: "সপ্তাহ",
        day: "বার",
        list: "তালিকা"
    },
    weekLabel: "সপ্তাহ",
    allDayText: "পূর্ণ দিন ব‍্যাপী",
    eventLimitText: "অন‍্যান‍্য",
    noEventsMessage: "কোন ইভেন্ট নেই"
});